module.exports = __webpack_public_path__ + "SeaweedScript-Regular.84f430003e43b0318718.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/assets/font/SeaweedScript-Regular.ttf
// module id = ../../../../../src/assets/font/SeaweedScript-Regular.ttf
// module chunks = styles